import { CopyOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { TextAreaProps } from "antd/es/input";
import classNames from "classnames";
import React, { FC, useState, useEffect, useRef } from "react";

const READONLY_STYLES = "bg-[#EBF5F566] focus:bg-[#EBF5F566] hover:bg-[#EBF5F566] border-[#BFDFDF]";

interface ExtendedTextAreaProps extends TextAreaProps {
    /** "default" uses standard styling, "readonly" applies muted background styling */
    appearance?: "default" | "readonly";
}

export const TextArea: FC<ExtendedTextAreaProps> = (props) => {
    const { rootClassName, className, appearance = "default", ...restProps } = props;
    const variantStyles = appearance === "readonly" ? READONLY_STYLES : "";
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const clickHandler = (e: React.MouseEvent) => {
        e.stopPropagation();
        const textToCopy = props.value ?? "";
        if (!textToCopy) return;

        navigator.clipboard.writeText(String(textToCopy))
            .then(() => {
                setCopied(true);
                timeoutRef.current = setTimeout(() => setCopied(false), 2000);
            })
            .catch((err) => {
                console.error("Failed to copy to clipboard:", err);
            });
    }

    return (
        <div className="relative w-full">
            <Input.TextArea
                rows={4}
                className={classNames(rootClassName, className, variantStyles, "pr-[25px]")}
                {...restProps}
            />
            <Button icon={!copied ? <CopyOutlined /> : <CheckOutlined />} color="primary" variant="text" onClick={clickHandler} className="absolute top-[4px] right-[4px]" disabled={copied} aria-label={copied ? "Copied" : "Copy to clipboard"} />
        </div>
    );
}

